import styled from "styled-components";

export const Container = styled.section`
  @media screen and (min-width: 576px) {
    max-width: 540px;
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    max-width: 720px;
    margin: 0 auto;
  }

  @media screen and (min-width: 992px) {
    max-width: 960px;
    margin: 0 auto;
  }

  @media screen and (min-width: 1200px) {
    max-width: 1140px;
    margin: 0 auto;
  }

  @media screen and (min-width: 1400px) {
    max-width: 1320px;
    margin: 0 auto;
  }

  @media screen and (max-width: 576px) {
    max-width: 100%;
    margin: 0 15px;
  }
`;
